export const AUTO_SAVE_DEBOUNCE_MS = 250;
export const AUTO_SAVE_MAX_WAIT_MS = 10000;
